import React from 'react';
import { useDispatch } from 'react-redux';
import { confirmRegistration, confirmEmployeeInvitation } from '@/store/actions/auth';
import { decodeJwtPayload } from '@/utils/jwt';

const Confirm = (props) => {
  const dispatch = useDispatch();

  const _onClick = () => {
    const token = props.match.params.token;
    // The same `registration-confirm/<token>` URL is used for two flows;
    // the token's `token_type` claim decides which endpoint to call.
    const payload = decodeJwtPayload(token);

    if (payload?.token_type === 'employee_invitation') {
      dispatch(confirmEmployeeInvitation(token, payload.employee_id));
    } else {
      dispatch(confirmRegistration(token));
    }
    props.history.push('/');
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <span
        data-testid="confirm-registration-btn"
        style={{ color: 'blue', cursor: 'pointer' }}
        onClick={_onClick}
      >
        Potvrdit registraci
      </span>
    </div>
  );
};

export default Confirm;
